import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-semibold leading-6 text-gray-900" }, "Login count"),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "En çok oturum açmış kullanıcıları gösterir. ")
  ])
], -1)
const _hoisted_2 = { class: "mt-8 flow-root" }
const _hoisted_3 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_4 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_5 = {
  key: 0,
  class: "min-w-full divide-y divide-gray-300"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
    }, " e-Mail"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Login count"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Last login date")
  ])
], -1)
const _hoisted_7 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_8 = { class: "whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-0" }
const _hoisted_9 = { class: "whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900" }
const _hoisted_10 = { class: "whitespace-nowrap px-2 py-2 text-sm text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.reportUserByLoginCountResult && _ctx.reportUserByLoginCountResult.items)
            ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("tbody", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportUserByLoginCountResult.items, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.eMail
                    }, [
                      _createElementVNode("td", _hoisted_8, _toDisplayString(item.eMail), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(item.loginCount), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.formatDateLong(item.lastLoginDate)), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}